import { render } from "./zsgk.vue?vue&type=template&id=1fd86692&scoped=true&ts=true"
import script from "./zsgk.vue?vue&type=script&lang=ts"
export * from "./zsgk.vue?vue&type=script&lang=ts"

import "./zsgk.vue?vue&type=style&index=0&id=1fd86692&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fd86692"]])

export default __exports__